export const products = [
  // Women's Collection
  // Men's Collection
  {
    id: 'cartier-ring',
    name: 'Cartier Ring',
    category: 'rings',
    description: 'Elegant Cartier ring design featuring the iconic screw motif. Available in multiple precious metals.',
    images: ['/images/products/cartier-ring.png'],
    price: 1170,
    gender: 'unisex',
    variants: [
      { metal: '18k Gold', price: 1170 },
      { metal: '14k Gold', price: 775 },
      { metal: '10k Gold', price: 535 },
      { metal: 'Silver', price: 80 }
    ]
  },
  {
    id: 'miami-cuban-ring',
    name: "Miami's Cuban Ring",
    category: 'rings',
    description: 'Classic Miami Cuban link design in ring form, showcasing intricate craftsmanship.',
    images: ["/images/products/miami's cuban ring.png"],
    price: 840,
    gender: 'men',
    variants: [
      { metal: '18k Gold', price: 840 },
      { metal: '14k Gold', price: 595 },
      { metal: '10k Gold', price: 390 },
      { metal: 'Silver', price: 75 }
    ]
  },
  {
    id: 'miami-cuban-infinity-chain',
    name: 'Miami Cuban/Infinity Links Chain',
    category: 'necklaces',
    description: '22 inch 10mm Miami Cuban chain with infinity links. Optional diamond settings available for ultimate luxury.',
    images: ['/images/products/Miami-Cuban-infinity links.png'],
    price: 9687,
    gender: 'men',
    variants: [
      { metal: '18k Gold', price: 9687 },
      { metal: '14k Gold', price: 6817 },
      { metal: '10k Gold', price: 4927 },
      { metal: 'Silver', price: 1747 }
    ],
    diamonds: {
      carats: 8.84,
      options: [
        { type: 'Lab VS', price: 3757 },
        { type: 'Lab VVS', price: 4641 },
        { type: 'Natural VS', price: 6851 },
        { type: 'Natural VVS', price: 7735 }
      ],
      settingCost: 1056
    }
  },
  {
    id: 'flower-cluster-earrings',
    name: 'Flower Cluster Earrings',
    category: 'earrings',
    description: 'Beautiful flower cluster design earrings with optional diamond settings for added sparkle.',
    images: ['/images/products/FlowerClusterearrings.jpg'],
    price: 120,
    gender: 'women',
    variants: [
      { metal: '14k Gold', price: 120 },
      { metal: '10k Gold', price: 105 },
      { metal: 'Silver', price: 53 }
    ],
    diamonds: {
      carats: 1.28,
      options: [
        { type: 'Lab VS', price: 544 },
        { type: 'Lab VVS', price: 672 },
        { type: 'Natural VS', price: 992 },
        { type: 'Natural VVS', price: 1120 }
      ]
    }
  },
  {
    id: 'septum-piercing',
    name: 'Septum Piercing',
    category: 'piercings',
    description: 'Elegant septum piercing with optional diamond accents.',
    images: ['/images/products/Septumpiercing.jpg'],
    price: 436,
    gender: 'unisex',
    variants: [
      { metal: '18k Gold', price: 436 },
      { metal: '14k Gold', price: 162 },
      { metal: '10k Gold', price: 128 },
      { metal: 'Silver', price: 72 }
    ],
    diamonds: {
      options: [
        { type: 'Lab VS', price: 7 },
        { type: 'Lab VVS', price: 10 },
        { type: 'Natural VS', price: 13 },
        { type: 'Natural VVS', price: 16 }
      ]
    }
  },
  {
    id: 'bird-ring',
    name: 'Bird Ring',
    category: 'rings',
    description: 'Unique bird design ring with optional diamond setting.',
    images: ['/images/products/Birdring.jpg'],
    price: 508,
    gender: 'women',
    variants: [
      { metal: '18k Gold', price: 508 },
      { metal: '14k Gold', price: 356 },
      { metal: '10k Gold', price: 255 },
      { metal: 'Silver', price: 92 }
    ],
    diamonds: {
      carats: 0.39,
      options: [
        { type: 'Lab VS', price: 165 },
        { type: 'Lab VVS', price: 205 },
        { type: 'Natural VS', price: 303 },
        { type: 'Natural VVS', price: 342 }
      ],
      settingCost: 57
    }
  },{
    id: 'Size-17-diamond-bracelet',
    name: 'Size 17 diamond bracelet',
    category: 'bracelets',
    description: 'Size 17 diamond bracelet optional diamond accents.',
    images: ['/images/products/17Diamondbracelet.jpg'],
    price: 2712,
    gender: 'unisex',
    variants: [
      { metal: '18k Gold', price: 2712 },
      { metal: '14k Gold', price: 1918 },
      { metal: '10k Gold', price: 1255 },
      { metal: 'Silver', price: 133 }
    ],
    diamonds: {
      carats: 2.21,
      options: [
        { type: 'Lab VS', price: 939 },
        { type: 'Lab VVS', price: 1160 },
        { type: 'Natural VS', price: 1700 },
        { type: 'Natural VVS', price: 1930 }
      ]
    }
  },{
    id: 'Diamond-Snake-Ring',
    name: 'Diamond Snake Ring',
    category: 'rings',
    description: 'Elegant Diamond Snake ring with optional diamond accents.',
    images: ['/images/products/snake-ring.jpg'],
    price: 1115,
    gender: 'women',
    variants: [
      { metal: '18k Gold', price: 1115 },
      { metal: '14k Gold', price: 761 },
      { metal: '10k Gold', price: 529 },
      { metal: 'Silver', price: 146 }
    ],
    diamonds: {
      carats: 1.82,
      options: [
        { type: 'Lab VS', price: 774 },
        { type: 'Lab VVS', price: 956 },
        { type: 'Natural VS', price: 1410 },
        { type: 'Natural VVS', price: 1592 }
      ]
    }
  },
  {
    id: 'mens-wedding-band-1',
    name: '1/2 ctw Round Lab Grown Diamond Men\'s Wedding Band',
    category: 'rings',
    description: '14K White Gold, F, VS2',
    images: [
      '/images/products/menweddingband1.jpg',
      '/images/products/menweddingband2.jpg'
    ],
    price: 1375,
    gender: 'men',
    variants: [
      { metal: '14k White Gold', price: 1375 }
    ]
  },
  {
    id: 'pinky-ring-1',
    name: 'näas Ethereal 1/15 ctw Round Lab Grown Diamond Pinky Ring',
    category: 'rings',
    description: '14K White Gold, F, VS2',
    images: [
      '/images/products/diamondpinkyring1.jpg',
      '/images/products/Diamondpinkyring2.jpg'
    ],
    price: 300,
    gender: 'unisex',
    variants: [
      { metal: '14k White Gold', price: 300 }
    ]
  },
  {
    id: 'ap-royal-oak-1',
    name: 'Audemars Piguet Royal Oak 18K/Steel 33MM VS Diamond Watch',
    category: 'high-jewelry',
    description: 'MODEL/SKU WTCH-34194 | 17.5 Ct VS Diamonds',
    images: [
      '/images/products/Diamondwatch1.jpg',
      '/images/products/Diamondwatch2.jpg',
      '/images/products/Diamondwatch3.jpg',
      '/images/products/Diamondwatch4.jpg'
    ],
    price: 25550,
    gender: 'unisex',
    variants: [
      { metal: '18k Gold/Steel', price: 25550 }
    ]
  },
  {
    id: 'rolex-datejust-1',
    name: 'Rolex Datejust 41MM Two-Tone 126331 Sundust Dial Watch',
    category: 'high-jewelry',
    description: 'MODEL/SKU WTCH-49388',
    images: [
      '/images/products/sundustwatch.jpg',
      '/images/products/sundustwatch2.jpg'
    ],
    price: 15000,
    gender: 'unisex',
    variants: [
      { metal: 'Two-Tone', price: 15000 }
    ]
  },
  {
    id: 'solitaire-earrings-1',
    name: '3 Prong Solitaire 1CT Diamond 14k Gold Earrings',
    category: 'earrings',
    description: 'MODEL/SKU EAR-46846',
    images: [
      '/images/products/goldearring1.jpg',
      '/images/products/goldearring2.jpg',
      '/images/products/goldearring3.jpg'
    ],
    price: 2700,
    gender: 'unisex',
    variants: [
      { metal: '14k Gold', price: 2700 }
    ]
  },
  {
    id: 'heart-ring-1',
    name: 'näas 1 ctw Heart Lab Grown Diamond Half Bezel Stackable Ring',
    category: 'rings',
    description: '14K Yellow Gold, FG, VS2+ | IGI Certified, 1 ct',
    images: [
      '/images/products/heartring1.jpg',
      '/images/products/heartring2.jpg'
    ],
    price: 1575,
    gender: 'women',
    variants: [
      { metal: '14k Yellow Gold', price: 1575 }
    ]
  },
  {
    id: 'tennis-bracelet-1',
    name: '3 ctw Round Lab Grown Diamond Tulip Prong Tennis Bracelet',
    category: 'bracelets',
    description: '14K White Gold, F, VS2 | 7 Inches',
    images: [
      '/images/products/prongtennisbracelet1.jpg',
      '/images/products/prongtennisbracelet2.jpg'
    ],
    price: 1750,
    gender: 'women',
    variants: [
      { metal: '14k White Gold', price: 1750 }
    ]
  },
  {
    id: 'jewel-of-the-sea-1',
    name: 'JEWEL OF THE SEA',
    category: 'high-jewelry',
    description: 'Emerald Cut, Marquise & Pear Shape Diamonds | Total Diamond Weight: 18.78 ct | Diamond Color: E - G | Diamond Clarity: VVS - VS | Platinum | Metal Wt: 44.24 gms | Prong Set | Length: 7 Inches',
    images: [
      '/images/products/jewelsea1.jpg',
      '/images/products/jewelsea2.jpg'
    ],
    price: 45000,
    gender: 'women',
    variants: [
      { metal: 'Platinum', price: 45000 }
    ]
  },
  {
    id: 'mi-amore-1',
    name: 'Mi Amore',
    category: 'high-jewelry',
    description: 'Heart Shape, Marquise, Pear & Round Diamonds | Total Diamonds Weight: 21.95 ct | Center Solitaire: Heart Shape 1.08 ct | Diamonds Color: Fancy Light - Fancy Yellow, Fancy Pink, G - I | Diamonds Clarity: VS - SI | 18K White Gold | Metal Wt: 39.58 gms | Prong Set | Length: 16 Inches',
    images: [
      '/images/products/miamore1.jpg',
      '/images/products/miamore2.jpg'
    ],
    price: 57500,
    gender: 'women',
    variants: [
      { metal: '18k White Gold', price: 57500 }
    ]
  }
];

export const categories = {
  accessories: {
    name: 'Accessories',
    description: 'Luxury accessories including cufflinks and tie pins',
    image: '/images/categories/accessories.png'
  },
  rings: {
    name: 'Rings',
    description: 'Luxury rings in various styles and precious metals',
    image: '/images/categories/rings.png'
  },
  necklaces: {
    name: 'Necklaces',
    description: 'Premium chains and necklaces',
    image: '/images/categories/necklaces.png'
  },
  earrings: {
    name: 'Earrings',
    description: 'Elegant earrings and studs',
    image: '/images/categories/earrings.png'
  },
  piercings: {
    name: 'Piercings',
    description: 'High-quality body jewelry',
    image: '/images/categories/piercings.png'
  },
  bracelets: {
    name: 'Bracelets',
    description: 'High-quality bracelets',
    image: '/images/categories/piercings.png'
  },
  'high-jewelry': {
    name: 'High Jewelry',
    description: 'Exclusive luxury pieces and fine jewelry',
    image: '/images/categories/high-jewelry.png'
  }
};

export const getProductsByCategory = (categoryId) => {
  return products.filter(product => product.category === categoryId);
};

export const getProductById = (productId) => {
  return products.find(product => product.id === productId);
};

export const getCategoryById = (categoryId) => {
  return categories[categoryId];
};
